import React from 'react';
import { Link } from 'react-router-dom';

import { Callout, Step } from './shared';

const SignIn: React.FC = () => (
  <div>
    <h2 className="text-2xl font-bold mb-4">Sign In</h2>
    <p className="text-sm text-base-content/70 mb-5 leading-relaxed">
      MFlow uses <strong>Google authentication</strong> via Firebase, so there is no separate password to manage. A
      guest (anonymous) mode is also available if you want to explore without a Google account.
    </p>

    <h3 className="font-semibold mb-3">Sign in with Google</h3>
    <div className="space-y-3 mb-6">
      <Step n={1}>
        Go to{' '}
        <Link to="/auth" className="link link-primary">
          app.m-flow.io/auth
        </Link>{' '}
        or click <strong>Sign In</strong> at the top of any page.
      </Step>
      <Step n={2}>
        Click <strong>Sign in with Google</strong>. A browser popup will appear asking you to choose a Google account.
      </Step>
      <Step n={3}>
        Select your work or personal Google account. MFlow only reads your email address and display name — it does not
        access Gmail or Google Drive unless you explicitly connect those integrations.
      </Step>
      <Step n={4}>
        After approval you are redirected to the <strong>Dashboard</strong>. If this is your first visit, the onboarding
        flow will guide you through connecting a platform.
      </Step>
    </div>

    <h3 className="font-semibold mb-3">Sign in as Guest</h3>
    <p className="text-sm text-base-content/70 mb-3 leading-relaxed">
      Guest mode creates a temporary anonymous account. All data synced during a guest session is automatically deleted
      when you log out.
    </p>
    <Callout type="warning">
      Guest sessions do not persist across devices. If you clear your browser data or log out, the session and all
      linked integrations are permanently removed.
    </Callout>
  </div>
);

export default SignIn;
